<template>
    <div id="home-page" class="wide content">
        <div class="main-files">
            <h3>{{ folderPath }}</h3>

            <toolbox @save-folder="saveFolder" @refresh-items="doRefresh" @update-sorting="doRefresh" />
            <file-list v-model="cwd" />
            <div class="instructions">
              <p>
              <img src="../assets/red-padlock.png" alt="Lock Icon" />
              Note: You may click on locked folders to request access.
              </p>
            </div>
        </div>
        <div class="quick-files">
            <h3>My Portfolio</h3>
            <portfolio />
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import FileList from '../components/FileList.vue'
import Toolbox from '../components/Toolbox.vue'
import Portfolio from '../components/Portfolio.vue'

import {mapState} from 'vuex'

export default {
  name: 'home-page',
  components: {FileList, Toolbox, Portfolio},
  data() {
    return {
      // cwd: {},
    }
  },
  computed: {
    ...mapState(['cwd', 'sortMethod']),
    pageTitle() {
      return this.cwd.display_name ? this.cwd.display_name : 'Master Folder List'
    },
    folderPath() {
      if (this.cwd.folder == 'Root' || this.cwd.folder === undefined) {
        return 'Master Folder List'
      }
      let parts = this.cwd.folder.split('.')
      let p = parts.slice(1, parts.length - 1)
      p.push(this.cwd.display_name)
      return p.map(i => i.replace(/_/g, ' ')).join(' › ')
    },
  },
  methods: {
    async getCWD(id=0) {
      // let r = await axios.get('/api/files/get-cwd', {params: {path: id}})
      let params = {}

      if (this.sortMethod) {
        params.order = this.sortMethod
      }

      let r = await axios.get(`/api/files/${id}`, {params})

      if (r.status != 200) {
        return;
      }

      // this.cwd = r.data.file
      this.$store.dispatch('setCwd', r.data.file)
    },
    async saveFolder(data) {
      let r = await axios.post('/api/files/create-folder', {
        file: {
          display_name: data.folderName,
          folder: this.cwd.folder,
          filename: '.',
          public: data.publicFolder,
        }
      })

      this.getCWD(this.$route.params.folder)
    },
    doRefresh() {
      this.getCWD(this.$route.params.folder)
    }
  },
  created() {
    this.getCWD(this.$route.params.folder)
  },
  beforeRouteUpdate(to, from, next) {
    this.getCWD(to.params.folder)
    next()
  }
}
</script>
<style lang="scss">
@import '../scss/include-media';

#home-page {
    padding: 50px 75px;

    @include media('<tablet') {
        padding: 25px;
        min-height: 50vh;
    }
    @include media('>=tablet') {
        padding: 25px;
        min-height: 60vh;
    }

    display: grid;
    grid-template-areas: "main quick";
    grid-template-columns: 3fr 1fr;
    

    h3 {
        font-size: 1.5rem;
    }

    .main-files {
        grid-area: main;
    }
    .quick-files {
        grid-area: quick;
        background: #F0F0F0;
        padding: 16px 26px;

        h3 {
            line-height: 1;
        }
    }
    .instructions {
      margin: 5rem 1rem 0.5rem;
      padding: 0 1rem;

      img {
        vertical-align: middle;
        position: relative;
        top: -3px;
      }
      p {
        line-height: 1;
        font-size: 13px;
      }
    }
}
</style>
